import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 16px;
    text-align: left;
    white-space: nowrap;
    border-bottom: 3px solid white;
  }

  th {
    font-size: 12px;
    color: #202020;
    max-width: 165px;
    white-space: wrap;
    background-color: white;
    font-weight: 600;
  }

  tr {
    font-size: 12px;
    color: #525252;
    font-weight: 500;
    background-color: #f5f5f5;
  }

  tr:hover {
    color: #222;
    background-color: #f7941d1a;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 8px;
    }
  }
`;
